import React, { useState } from 'react';
import clsx from 'clsx';
import Button, { ButtonType } from '../Button/Button';
import { useIsActiveMenuItem } from './useActiveMenuItem';
import Menu from './Menu';
import styles from './Navigation.module.scss';
import { INavigationItem } from './Navigation.type';

interface NavigationItemDesktopProps {
  item: INavigationItem;
}

const NavigationItemDesktop: React.FC<NavigationItemDesktopProps> = ({ item }) => {
  const [isHovered, setIsHovered] = useState(false);
  const isActive = useIsActiveMenuItem(item.link);
  const isSubMenu = item.menu && item.menu.length > 0;
  const closeMenu = () => {
    setIsHovered(false);
  };

  return (
    <div
      className={clsx(styles.desktopNavItem, {
        [styles.isHovered]: isHovered && isSubMenu,
      })}
      onMouseEnter={() => setIsHovered(true)}
      onMouseLeave={() => setIsHovered(false)}
    >
      <Button
        type={ButtonType.TEXT_DARK}
        className={clsx(styles.categoryLink, {
          [styles.active]: isActive,
        })}
        href={item.link}
        iconName={item.menu && item.menu.length ? 'keyboard_arrow_down' : ''}
        iconSize={24}
        iconClassName={styles.dropdownIcon}
      >
        {item.title}
      </Button>

      {item.menu && item.menu.length > 0 && (
        <Menu
          menu={item.menu}
          isOpen={isHovered}
          onClick={closeMenu}
        />
      )}
    </div>
  );
};

export default NavigationItemDesktop;
